import React, { useCallback, useState, useEffect } from 'react';
//@ts-ignore
import { debounce } from 'lodash';
import useScrollPosition from '@react-hook/window-scroll';
import { VideoComponent } from './videoComponent';
import { Dropbox } from 'dropbox';
import { subscribeToTimer, sendForm, removeListner } from './api';
import alertBox from '../assets/images/alert_box.png';
import folderImage from '../assets/images/folder.png';
import backImage from '../assets/images/back.png';
import dropBoxLogo from '../assets/images/dropbox.png';
import lineBreak from '../assets/images/LinkBreak.png';
import spinner from '../assets/images/spinner.gif';
import { IListDocumentsProps } from './listDocuments.types';

export const ListDocuments = (props : IListDocumentsProps) => {

  const { rootId, onSignOut, token, signInUpdate, getDropboxFileData } = props

  const [doc, setDocuments] = useState([]);
  const [folder, setFolders] = useState([]);
  const [nxtPgToken, setNxtPgToken] = useState();
  const [level, setLevel] = useState(0);
  const [parent, setParent] = useState(['']);
  const [rootDirId, setRootDirId] = useState('');
  const [current, setCurrent] = useState('');
  const [selectedId, setSelectId] = useState('');
  const [url, setUrl] = useState('');
  const [searchText, setSearchText] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [path, setPath] = useState('');
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const [itemLoading, setItemLoading] = useState(true);
  const [searchedText, setSearchedText] = useState('');
  const [accessToken, setAccessToken] = useState(token);
  const [progress, setProgress] = useState(0);
  const [progressSate, setProgressSate] = useState('Importing');
  const [mimeType, setMimeType] = useState('');

  let sId = '';
  const search = (value : any) => {
    setDocuments([]);
    setFolders([]);
    //@ts-ignore
    setNxtPgToken('');
    setSearchText(value);
    if (value) {
      delayedQuery(`name contains '${value}'`);
    } else {
      delayedQuery('');
    }
  };

  const scroll = useScrollPosition();

  const gaSearch = (q : any) => {
    setSearchQuery(q);
  };

  const delayedQuery = useCallback(
    debounce((q : any) => gaSearch(q), 500),
    []
  );

  useEffect(() => {
    setCurrent(rootId);
    setRootDirId(rootId);
  }, [rootId]);

  useEffect(() => {
    const getJsonFromUrl = (str : any) => {
      const query = str.substr(1);
      const result = {};

      query.split('&').forEach((part : any) => {
        const item = part.split('=');
        //@ts-ignore
        result[item[0]] = decodeURIComponent(item[1]);
      });

      return result;
    };

    if (!accessToken) {
      const result = getJsonFromUrl(window.location.hash);
      //@ts-ignore
      if (!result || !result.access_token) {
        return onSignOut();
      }
      //@ts-ignore
      setAccessToken(result.access_token);
      signInUpdate();
    }
  }, [token, accessToken]);

  const itemOnClick = (element : any) => {
    const id = element.id;
    const urlD = element.link;
    const defaultContainer = document.querySelectorAll('.item');
    defaultContainer.forEach((ele) => {
      //@ts-ignore
      ele.style = 'border:none;';
    });
    if (sId !== id) {
      //@ts-ignore
      document.getElementById(id).style.border = '2px solid #168CFF';
      sId = id;
      setSelectId(id);
      setUrl(urlD);
      setPath(element.path_display);
      setName(element.name);
      if (element.path_lower.includes('.mp4') || element.path_lower.includes('.mov')) {
        setMimeType('video');
      } else {
        setMimeType('image');
      }
      onItemClick(element)
    } else {
      sId = '';
      setSelectId('');
      setUrl('');
      setPath('');
      setName('');
      setMimeType('');
    }
  };

  const onItemClick = (element: any) => {
    setLoading(true);
    const payload = {
      token,
      path: element.path_display,
      name: element.name,
      mimeType,
      file_id: selectedId,
    };
  
    const defaultContainer = document.querySelectorAll('.item');
    defaultContainer.forEach((ele) => {
      //@ts-ignore
      ele.style = 'border:none;';
    });
    sendForm(payload);
    subscribeToTimer('download-dropbox-progress', (err : any, progress_state : any, progress : any) => {
      setProgress(progress);
      setProgressSate(progress_state);

      if(err){
        const alterDiv = document.getElementById('alert_message');
         //@ts-ignore
         alterDiv.style.display = 'block'
          setTimeout(() => {
            //@ts-ignore
            alterDiv.style.display = 'none'
            window.location.reload()
          }, 1500)
      }

    });
    subscribeToTimer('download-dropbox-final', (err : any, final_data : any, data : any) => {
      const returnJson = {
        action: 'create',
        type: final_data.type,
        file: final_data.final_data,
        fileSize: final_data.fileSize,
        thumbnail: final_data.final_data,
      };

      if(err){
        const alterDiv = document.getElementById('alert_message');
         //@ts-ignore
         alterDiv.style.display = 'block'
          setTimeout(() => {
            //@ts-ignore
            alterDiv.style.display = 'none'
            window.location.reload()
          }, 1500)
      }

      getDropboxFileData(returnJson);
      //@ts-ignore
      if (window.vlogr) {
        //@ts-ignore
        window.vlogr.addData(1, JSON.stringify(returnJson));
      }

      function iOS() {
        return ['iPad Simulator','iPhone Simulator','iPod Simulator','iPad','iPhone','iPod'].includes(navigator.platform)
       // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      }

      if (iOS()) {
        var paramString = Object.entries(returnJson)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        window.location.href = 'vlogrPluginData://' + paramString;
      }

      if (window.top) {
        window.top.postMessage(returnJson, '*');
      }
      sId = '';
      setSelectId('');
      setUrl('');
      setPath('');
      setLoading(false);
      setProgressSate('Importing')
      setTimeout(() => {
        setProgress(0);
      }, 500);
    })
  }

  useEffect(() => {
    if(progressSate === 'Imported'){
      setTimeout(() => {
        removeListner('download-drive-final')
      },1000)
    } 
  },[progressSate])

  const handleChange = (e : any) => {
    e.preventDefault();
    search(e.target.value);
  };

  const handleAdd = async () => {
    setLoading(true);
    const payload = {
      token,
      path,
      name,
      mimeType,
      file_id: selectedId,
    };
    const defaultContainer = document.querySelectorAll('.item');
    defaultContainer.forEach((ele) => {
      //@ts-ignore
      ele.style = 'border:none;';
    });
    sendForm(payload);
    subscribeToTimer('download-dropbox-progress', (err : any, progress_state : any, progress : any) => {
      setProgress(progress);
      setProgressSate(progress_state);

      if(err){
        const alterDiv = document.getElementById('alert_message');
         //@ts-ignore
         alterDiv.style.display = 'block'
          setTimeout(() => {
            //@ts-ignore
            alterDiv.style.display = 'none'
            window.location.reload()
          }, 1500)
      }

    });
    subscribeToTimer('download-dropbox-final', (err : any, final_data : any, data : any) => {
      const returnJson = {
        action: 'create',
        type: final_data.type,
        file: final_data.final_data,
        fileSize: final_data.fileSize,
      };

      if(err){
        const alterDiv = document.getElementById('alert_message');
         //@ts-ignore
         alterDiv.style.display = 'block'
          setTimeout(() => {
            //@ts-ignore
            alterDiv.style.display = 'none'
            window.location.reload()
          }, 1500)
      }

      getDropboxFileData(returnJson);
      //@ts-ignore
      if (window.vlogr) {
        //@ts-ignore
        window.vlogr.addData(1, JSON.stringify(returnJson));
      }

      function iOS() {
        return ['iPad Simulator','iPhone Simulator','iPod Simulator','iPad','iPhone','iPod'].includes(navigator.platform)
       // iPad on iOS 13 detection
        || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
      }

      if (iOS()) {
        var paramString = Object.entries(returnJson)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        window.location.href = 'vlogrPluginData://' + paramString;
      }

      if (window.top) {
        window.top.postMessage(returnJson, '*');
      }
      sId = '';
      setSelectId('');
      setUrl('');
      setPath('');
      setLoading(false);
      setTimeout(() => {
        setProgress(0);
      }, 500);
    })
  };

  const handleBackClick = () => {
    const current_id = parent[parent.length - 1];
    let parent_arr = [...parent];
    parent_arr.pop();
    setSearchText('');
    setSearchedText('');
    //@ts-ignore
    setNxtPgToken('');

    setDocuments([]);

    setFolders([]);
    setParent(parent_arr);
    setCurrent(current_id);
  };

  const handleDirectoryClick = (path : any) => {
    setSearchText('');
    setSearchedText('');
    let new_level = level + 1;
    setLevel(new_level);
    setFolders([]);
    setDocuments([]);
    let parent_arr = [...parent];
    parent_arr.push(current);
    setParent(parent_arr);
    setCurrent(path);
  };

  const renderDocument = async (documents : any, dbx : any) => {
    const docs = [];
    for await (let element of documents) {
      if (element['.tag'] === 'folder') {
        continue;
      }
      const res = await dbx.filesGetTemporaryLink({
        path: element.path_lower,
      });
      element.link = res.result.link;
      if (!Array.isArray(element.parents) || !element.parents[0] || current === element.parents[0]) {
        if (element.path_lower.includes('.mp4') || element.path_lower.includes('.mov')) {
          const path_doc = await dbx.filesGetThumbnail({ path: element.path_display });
          element.videoMediaMetadata = {
            durationMillis: path_doc.result.media_info.metadata.duration,
          };
          element.thumbnail = window.URL.createObjectURL(path_doc.result.fileBlob);
          //@ts-ignore
          docs.push(<VideoComponent className="item" id={element.id} itemOnClick={itemOnClick} element={element} />);
        } else {
          docs.push(
            <div
              className="item"
              id={element.id}
              onClick={(e) => {
                itemOnClick(element);
              }}
            >
              <img
                src={res.result.link}
                alt={''}
                style={{ padding: '2px', maxWidth: '100%', maxHeight: '148px', margin: 'auto' }}
              ></img>
            </div>
          );
        }
      }
    }
    const updated_doc: any = [...doc, ...docs];
   
    setDocuments(updated_doc);
    setItemLoading(false);
  };

  const renderFolders = (directories : any) => {
    const dir = [];
    if (parent && parent.length > 1 && folder.length === 0) {
      dir.push(
        <div
          className={'directory-display'}
          onClick={() => {
            handleBackClick();
          }}
        >
          <img style={{ paddingTop: '20px' }} src={backImage} alt={''} height="auto" width="auto"></img>
          <div className={'directory-name'}>back</div>
        </div>
      );
    }
    for (let index = 0; index < directories.length; index++) {
      const element = directories[index];
      if (element['.tag'] === 'folder') {
        dir.push(
          <div
            className={'directory-display'}
            onClick={() => {
              handleDirectoryClick(element.path_display);
            }}
          >
            <img style={{ paddingTop: '20px' }} src={folderImage} alt={''} height="auto" width="auto"></img>
            <div className={'directory-name'}>{element.name}</div>
          </div>
        );
      }
    }
    const updated_folder = [...folder, ...dir];
    //@ts-ignore
    setFolders(updated_folder);
  };

  useEffect(() => {
    const loadMore = async () => {
      setItemLoading(true);
      if (searchText) {
        const dbx = new Dropbox({ accessToken: accessToken });
        const response = await dbx.filesSearchContinueV2({
          //@ts-ignore
          cursor: nxtPgToken,
        });

        if (response && response.result) {
          const arr = response.result.matches;
          const elements = arr.map((ele) => {
            //@ts-ignore
            return ele.metadata.metadata;
          });
          renderDocument(elements, dbx);
          renderFolders(elements);
          if (response.result.has_more) {
            //@ts-ignore
            setNxtPgToken(response.result.cursor);
          } else {
            //@ts-ignore
            setNxtPgToken('');
          }
        }
      } else {
        const dbx = new Dropbox({ accessToken: accessToken });
        const response = await dbx.filesListFolderContinue({
          //@ts-ignore
          cursor: nxtPgToken,
        });
        if (response && response.result && response.result.entries) {
          renderDocument(response.result.entries, dbx);
          renderFolders(response.result.entries);
        }
        if (response.result.has_more) {
            //@ts-ignore
          setNxtPgToken(response.result.cursor);
        } else {
            //@ts-ignore
          setNxtPgToken('');
        }
      }
      setTimeout(() => {
        setItemLoading(false);
      }, 10000);
    };
    var totalPageHeight = document.body.scrollHeight;
    var scrollPoint = window.scrollY + window.innerHeight;
    let percentage = (scrollPoint / totalPageHeight) * 100;
    if (percentage >= 99.5 && nxtPgToken) {
      setTimeout(() => {
        loadMore();
      }, 500);
    }
  }, [scroll]);

  useEffect(() => {}, [doc]);

  useEffect(() => {
    const loadDirectory = async () => {
      const dbx = new Dropbox({ accessToken: accessToken });
      const response = await dbx.filesListFolder({
        path: current,
        include_media_info: true,
        recursive: false,
        limit: 20,
      });
      if (response && response.result && response.result.entries) {
        renderDocument(response.result.entries, dbx);
        renderFolders(response.result.entries);
      }
      if (response.result.has_more) {
        //@ts-ignore
        setNxtPgToken(response.result.cursor);
      } else {
        //@ts-ignore
        setNxtPgToken('');
      }
    };

    const search = async () => {
      setItemLoading(true);
      const dbx = new Dropbox({ accessToken: accessToken });
      const response2 = await dbx.filesSearchV2({
        options: {
          path: current,
          //@ts-ignore
          file_categories: ['folder'],
          filename_only: true,
          max_results: 100,
        },
        query: searchText,
      });

      if (response2 && response2.result) {
        const arr = response2.result.matches;
        const elements = arr.map((ele) => {
          //@ts-ignore
          return ele.metadata.metadata;
        });
        renderFolders(elements);
      }

      const response = await dbx.filesSearchV2({
        options: {
          path: current,
          //@ts-ignore
          file_categories: ['image'],
          filename_only: true,
          max_results: 15,
        },
        query: searchText,
      });

      if (response && response.result) {
        const arr = response.result.matches;
        const elements = arr.map((ele) => {
            //@ts-ignore
          return ele.metadata.metadata;
        });
        renderDocument(elements, dbx);
        if (response.result.has_more) {
            //@ts-ignore
          setNxtPgToken(response.result.cursor);
        } else {
            //@ts-ignore
          setNxtPgToken('');
        }
      }
      setTimeout(() => {
        setItemLoading(false);
      }, 10000);
    };
    if (token && doc.length === 0) {
      if (searchText) {
        if (searchText !== searchedText) {
          search();
          setSearchedText(searchText);
        }
      } else {
        // if(!isMainFnCalled) {
        //   setMainFnCalled(true);
        loadDirectory();
        //}
      }
    }
  }, [current, searchText, accessToken]);

  const handleCancel = () => {
    //@ts-ignore
    window.location.reload(false)
   }

  return (
    //@ts-ignore
    <div style={{ textAlign: '-webkit-center' }}>
      {loading ? (
        <div>
          <div className={'logo-loading'}>
            <div style={{ float: 'right' }}>
              <img src={dropBoxLogo} height={'20px'} />
            </div>
          </div>
          <div
            style={{
              width: '100%',
              height: 'auto',
              marginTop: loading ? '50%' : '75%',
              zIndex: 102,
              textAlign: 'center',
              marginLeft: '0px',
            }}
          >
            <div>
              <p className="App-intro process-header">{progressSate}</p>
              <p className="warning"> Don't turn off the app or device.</p>
              <progress id="file" className="progress_bar" value={progress} max="100">
                {' '}
              </progress>
              <div className="w3-center w3-text-white text-color">{progress}%</div>
              <div>
                {progress != 100 ? (
                  <button className="cancel-button" type="reset" onClick={handleCancel}>
                    Cancel
                  </button>
                ) : (
                  <button className="cancel-button" type="reset" onClick={handleCancel}>
                    Cancel
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div>
          <div className={'top-fixed'}>
            <div className={'logo'}>
              <div style={{ float: 'right' }}>
                <img src={dropBoxLogo} height={'20px'} />
              </div>
            </div>
            <div className={'disconnect'}>
              <a style={{ float: 'left', color: '#404040' }} type="primary" onClick={onSignOut}>
                <img src={lineBreak} alt="" height={'16px'} />
                Disconnect
              </a>
            </div>
            <div className="search">
              <input
                className="search-input"
                type="text"
                value={searchText}
                onChange={(e) => {
                  handleChange(e);
                }}
              ></input>
            </div>
            
            <div className={'directory-div'} style={{ display: folder.length === 0 ? 'none' : '' }}>
              {folder}
            </div>
          </div>
          <div
            style={{
              maxWidth: '400px',
              display: 'flex',
              flexFlow: 'row wrap',
              paddingBottom: '80px',
              marginTop: folder.length === 0 ? '148px' : '255px',
            }}
          >
            {doc}
          </div>
          <div id='alert_message' style={{ width: '150px', height: '35px', alignItems: 'center', display: 'none', zIndex: 999, marginTop: '17.2em', marginLeft: '8em', position : 'absolute'}}>
            <span style={{ fontSize: '15px', fontWeight: '400', fontFamily: 'Inter', color: '#FFFFFF', marginTop: '7px', position: 'fixed', marginLeft: '30px' }}>Please try again</span>
            <img src={alertBox} width='151px' height='35px' alt='Alert box' />
          </div>
          <div style={{ display: itemLoading ? 'block' : 'none' }}>
            <img src={spinner} height="30px" alt={'loading ...'} />
          </div>
          <div className={'footer'} style={{ display: selectedId ? 'block' : 'none', zIndex: 999 }}>
            { /*JSX for the add button on selection on the doc*/ }
            {/* <button
              className={'connect-button'}
              style={{ marginLeft: '-9%', width: '88%' }}
              onClick={() => {
                handleAdd();
              }}
            >
              Add
            </button> */}
          </div>
        </div>
      )}
    </div>
  );
};